import { Component } from 'preact'

/* eslint-disable-next-line import/no-internal-modules */
import Overview from '@insided/deprecated-control/overview'
import { SegmentOverviewHeaderActionsComponent } from './HeaderActions'

// eslint-disable-next-line import/no-internal-modules
import tracker from '@insided/deprecated-components/tracker/publish'

import { SegmentData } from './types'
import { segmentsOverviewColumns } from './columns'
import { fetchData } from './dataSource'

class UserSegments extends Component<{}, {}> {
  componentDidMount() {
    tracker.trackEvent('userevent', {
      type: 'Segment overview viewed'
    })
  }

  render() {
    return (
      <Overview<SegmentData>
        type='UserSegments'
        headerTitle='Segments Overview'
        rowId='id'
        withColumns
        model={segmentsOverviewColumns}
        EmptyStateComponent={<h2 className='control_empty_message_header text-center'>There are no segments yet</h2>}
        StateAwareHeaderComponent={props => <SegmentOverviewHeaderActionsComponent {...props} />}
        dataSource={fetchData}
        withPagination={{
          page: 1,
          pageSize: 25,
          pageSizes: [10, 25]
        }}
        withMultiSelect={false}
      />
    )
  }
}

export default UserSegments
